import { NlpModel, NlpExample } from '@feedyou/schema'

import { useBotDefaultLocale, useBotId } from '../../store/flow'
import { nlpAnalyzerApi } from '../../features/nlp-analyzer/nlpAnalyzerApi'

export function useClassifyUtterance() {
  const botId = useBotId()
  const botDefaultLocale = useBotDefaultLocale()
  const request = nlpAnalyzerApi.endpoints.classifyUtterance.useMutation()

  return (models: NlpModel[]) => {
    const [triggerRequest, { isLoading }] = request
    return {
      isRequestInProgress: isLoading,
      triggerRequest: (utterance: NlpExample) =>
        triggerRequest({ botId, models, utterance, botDefaultLocale })
    }
  }
}
